<template lang="html">
  <div class="form-group form-group-horizontal" :class="groupClass">
    <div>
    <slot name="label">
      <FormGroupLabel :required="required">
            <span v-if="!noLabelTag" class="control-label" :class="labelClass">
                <slot name="label-after">{{ labelText }}</slot>
            </span>
      </FormGroupLabel>
    </slot>
    </div>
    <div>
    <slot></slot>
    <slot name="hints"></slot>
    <slot name="errors"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>

import {computed} from "vue";
import FormGroupLabel from "@/components/forms/horizontal/FormGroupLabel.vue";

const props = defineProps({
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  hasErrors: {
    type: Boolean,
    default: false,
  },
  noLabelTag: {
    type: Boolean,
    default: false,
  },
})

const groupClass = computed(() => {
  return { 'has-error': props.hasErrors, 'form-group-has-error': props.hasErrors };
})

const labelText = computed(() => {
  return props.label && (props.label.length > 0) ? props.label : '';
})

const labelClass = computed(() => {
  return { required: props.required };
})
</script>


<style scoped lang="less">
.control-label {
  text-align: right;
  margin-bottom: 0;
  position: relative;

  &.required:after {
    content: "*";
    color: #ee4538;
    position: absolute;
    right: -7px;
    top: 0;
  }
}

.form-group {
  display: grid;
  grid-template-columns: 30% 1fr;
  grid-gap: 0 30px;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 15px;

  .control-label {
    text-align: right;
    margin-bottom: 0;
    position: relative;

    &.required:after {
      content: "*";
      color: #ee4538;
      position: absolute;
      right: -7px;
      top: 0;
    }
  }

}
</style>
